import React, { Component } from 'react';
import Header from '../Header/header';
import Footer from '../Footer/footer';
import getUserList from '../../services/getUserList';
import '../CompanyList/displayCompanyList.scss';
import { Navigate } from 'react-router-dom';
import deleteUser from '../../services/user/deleteUser';
import toastNotify from '../../utils/toastNotifier';
import withRouter from '../withRouter';
import cookie from '../../cookieHelper/cookie';
import { auth as AuthObject } from '../../services/login'

class DisplayUserList extends React.Component {
    constructor() {
        super();
        this.state = {
            rows: '',
            userListvalue: '',
            redirect: false,
            tokencheck: true,
        }

        this.role = {
            1: "Normal User",
            2: "Admin"
        }

        this.userList();
    }

    redirectHandler = () => {
        console.log("in redirectHandler");
        this.setState({
            redirect: true
        })
    }

    onSubmit = () => {
        console.log("Clicked Edit");
    }

    userList = async () => {
        let values = await getUserList();
        if(typeof values === 'undefined'){
            return toastNotify(3 , "No users found.");
        }
        else if(Object.keys(values).length === 0 ){
            return toastNotify(3 , "No users found.");
        }

        if(values.length)
        {
            let rows = values.map((item, index) => {
                return {
                    name: item.name,
                    email: item.email,
                    userId: item.userId,
                    companyId: item.companyId,
                    organisationName: item.organisationName,
                    role: item.role,
                    rowIndex: index
                }
            })
            this.setState({
                userListvalue: values,
                rows: rows
            })

        }
        else{
        
        const response = JSON.parse(values.request.response);
        const code = response?.status?.code;
        if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
            this.setState({ tokencheck: false });
            cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
            cookie.delete_cookie('loginProfileInfo');
            AuthObject.isAuthenticated = false;
        }

        }
    }

    onDelete = async (e, userId, index)=>{
        e.persist();
        e.preventDefault();
        
        try{
            let result = await deleteUser(userId); 
            e.target.parentElement.parentElement.classList.add("hidden");
        }
        catch(err){
            console.log(err);
        }
    }

    render() {

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        if (this.state.redirect) {
            return <Navigate to={'/user'} />
        }
        let rows;
        if (this.state.userListvalue) {
            rows = (
                this.state.userListvalue.map((item, index) => {

                    return (
                        // <tr storytype={props.fileType} >

                        <tr key={index}>
                            <td>
                                <div className="checkboxes">
                                    <p>{item.name}</p>

                                </div>
                            </td>
                            <td>

                                <div >
                                    <p>{item.email} </p>
                                </div>

                            </td>

                            <td>
                                <div className="checkboxes">
                                    <p>{item.userId}</p>

                                </div>
                            </td>
                            <td>
                                <div className="checkboxes">
                                    <p>{item.companyId}</p>

                                </div>
                            </td>
                            <td>
                                <div className="checkboxes">
                                    <p>{item.organisationName}</p>

                                </div>
                            </td>
                            <td>
                                <div className="checkboxes">
                                    <p>{this.role[item.role]}</p>

                                </div>
                            </td>

                            <td>
                                <button className="color_danger btn-default" onClick={(e) => this.onDelete(e,item.userId, index)}>Deactivate</button>
                            </td>
                        </tr>
                    )
                })
            )
        }


        return (
            <div className="bodyWrapper" onClick={this.eventHandleClick}>
                <Header />
                <section className="listing_header">

                    <div className="wrapper">
                        <div className="wrapperButton" onClick={this.redirectHandler}>Add New User</div>
    
                        <h1>Display User List</h1>

                        
                        <div className="wrapperTable">
                            <table border="1" className="mtb20 recruiter_listing" width="100%">
                                <tbody>
                                    <tr className="table-header">
                                        <th className="table_header">Name</th>
                                        <th className="table_header">Email</th>
                                        <th className="table_header">User ID</th>
                                        <th className="table_header">Company ID</th>
                                        <th className="table_header">Organization Name</th>
                                        <th className="table_header">Role</th>
                                        <th className="table_header ">Actions</th>
                                    </tr>
                                    {rows}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default withRouter(DisplayUserList);    